import React from 'react';
import { invoiceTotals } from './discount';

const money = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function InvoiceTotals({ lines, vatEnabled = true, currency = 'RON', amounts: suppliedAmounts }) {
  let amounts;
  try { amounts = suppliedAmounts ?? invoiceTotals(lines, vatEnabled); } catch { amounts = null; }
  return <section aria-label="Totaluri factură" aria-live="polite" className="border rounded bg-body-tertiary p-3 mb-3">
    <div className="d-flex flex-wrap justify-content-end gap-4">
      {[
        ['base', 'Total fără TVA'],
        ['vat', 'Total TVA'],
        ['total', 'Total de plată'],
      ].map(([key, label]) => <div key={key} className="text-end">
        <div className="small text-muted">{label}</div>
        <div className={key === 'total' ? 'fs-5 fw-bold' : 'fs-5'} data-testid={`invoice-${key}`}>
          {amounts ? money.format(amounts[key]) : '—'} <span className="small">{currency}</span>
        </div>
      </div>)}
    </div>
    {!amounts && <div className="text-muted small text-end mt-2">Completează cantitățile și prețurile pentru calculul totalurilor.</div>}
  </section>;
}
